import type { SyntheticEvent } from 'react';

type EventHandler = (arg1: SyntheticEvent) => void;

export const stopImmediatePropagation =
	(eventHandler: EventHandler) =>
	// menu should no close when user click on any button
	// and classic stopPropagation does not work because
	// "close popup" event is attached to document
	// Ref: https://github.com/facebook/react/blob/a1be17140d/packages/react-dom/src/events/ReactBrowserEventEmitter.js
	(e: SyntheticEvent) => {
		e.nativeEvent.stopImmediatePropagation();
		return eventHandler(e);
	};
